import { fetchApi } from "../utils/fetchApi";

export function fetchSummationsite({ filter = {}, options = {} }) {
  return fetchApi({ url: 'summationsite', filter, options });
}

